// extracted by mini-css-extract-plugin
export default {"users":"users_users__3bGFX","side":"users_side__4QmSj"};